<template>
  <div class="motion-safe:animate-pulse motion-reduce:animate-none">
    <span class="sr-only" role="status">
      {{ show ? 'Läser in Klarnas betalalternativ' : '' }}
    </span>
    <div v-if="show" class="w-full" aria-hidden="true">
      <div class="w-full pt-25 pb-8">
        <div class="flex flex-row flex-nowrap justify-between">
          <div class="flex flex-row items-center">
            <div class="w-28 h-28 rounded-full bg-text-disabled me-12"></div>
            <div class="flex flex-col">
              <div
                :class="`${upperRowTextWidthClass} h-18 mb-4 rounded-sm bg-text-disabled`"
              ></div>
              <div class="w-70 h-18 rounded-sm bg-text-disabled"></div>
            </div>
          </div>
          <div class="w-62 h-24 rounded-md bg-text-disabled"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  show: boolean;
  upperRowTextWidthSize: 'short' | 'medium' | 'long';
}
const props = defineProps<Props>();

const upperRowTextWidthClass = computed(() => {
  if (props.upperRowTextWidthSize === 'short') {
    return 'w-60';
  } else if (props.upperRowTextWidthSize === 'medium') {
    return 'w-100';
  } else {
    return 'w-190';
  }
});
</script>
